import React from 'react';
import { CircularProgress } from '@material-ui/core';
import useStyles from './CircularProgressBar.styles';

export type VariantProps = 'determinate' | 'indeterminate';

export interface CircularProgressProps {
  value?: number;
  dataQaId?: string;
  size?: number;
  variant?: VariantProps;
}

const CircularProgressBar: React.FC<CircularProgressProps> = ({
  value = 0,
  dataQaId = 'circular-progress-bar',
  size = 32,
  variant = 'determinate',
}) => {
  const classes = useStyles();
  return <CircularProgress value={value} data-qa-id={dataQaId} classes={classes} size={size} variant={variant} />;
};

export default CircularProgressBar;
